import { useAtom } from "jotai";

import ButtonGroup, { YES_OR_NO_OPTIONS } from "components/ButtonGroup";
import Text from "components/Text";

import { getQuestionAtom } from "atoms/PayeeQuestions/questions";
import { useClientTranslation } from "hooks/useClientTranslation";

import {
  PAYMENT_QUESTIONS,
  PAYMENT_QUESTIONS_TRANSLATION_KEYS,
} from "./constants";
import { PaymentQuestions } from "./types";

type IbanQuestionProps = {
  variant: keyof PaymentQuestions;
};

export const IbanQuestion = ({ variant }: IbanQuestionProps) => {
  const { t } = useClientTranslation();
  const translationKey = PAYMENT_QUESTIONS[variant];
  const decsriptionTranslationKey = PAYMENT_QUESTIONS_TRANSLATION_KEYS[variant];
  const [selected, setSelected] = useAtom(getQuestionAtom(variant));

  return (
    <ButtonGroup
      name={variant}
      value={selected}
      onChange={(value) => setSelected(value as boolean)}
      label={<Text sizeVariant="lg">{t(translationKey)}</Text>}
      description={decsriptionTranslationKey && <Text as="span">{t(decsriptionTranslationKey)}</Text>}
      options={YES_OR_NO_OPTIONS}
    />
  );
};
